module.exports = __webpack_public_path__ + "static/media/0331_IMG_LE_NON_AL.0805146b.webp";